const urlUserRepo = "https://api.github.com/users/ruan-andre";
const urlRepoContent = "https://api.github.com/repos/ruan-andre/";
const pathPortfolioContent = "/portfolio-content/content.json";

const urlReposFeatured = "https://api.github.com/search/repositories?q=topic:featured+user:Ruan-andre";
const urlAllRepos = "https://api.github.com/search/repositories?q=user:Ruan-andre";
export { urlReposFeatured, urlAllRepos, urlRepoContent, pathPortfolioContent, urlUserRepo };
